(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7hG31", function(module, exports) {

$parcel$export(module.exports, "uriUserPage", function () { return $54dabcb7a6480b63$export$ff3ad29dbb546598; });
$parcel$export(module.exports, "uriCollectionPage", function () { return $54dabcb7a6480b63$export$36dfaec04418caa7; });
$parcel$export(module.exports, "UserRole", function () { return $54dabcb7a6480b63$export$eb3485a690c2f0b8; });
$parcel$export(module.exports, "LevelPrivacy", function () { return $54dabcb7a6480b63$export$a3c073b335a47d60; });
$parcel$export(module.exports, "PRIVACY_BADGE_STYLE", function () { return $54dabcb7a6480b63$export$eba8c17f4d7a3cd3; });
$parcel$export(module.exports, "PRIVACY_BADGE_TEXT", function () { return $54dabcb7a6480b63$export$ab4fdfae3dcd1a8f; });
$parcel$export(module.exports, "ROLE_BADGE_STYLE", function () { return $54dabcb7a6480b63$export$f25eef55c66a4e9d; });
$parcel$export(module.exports, "startLoader", function () { return $54dabcb7a6480b63$export$8afc507ca675ea0e; });
$parcel$export(module.exports, "cancelLoader", function () { return $54dabcb7a6480b63$export$81e46b314cb8d8e3; });
$parcel$export(module.exports, "callJsonApi", function () { return $54dabcb7a6480b63$export$997d30e836e5c567; });
$parcel$export(module.exports, "looksLikeMail", function () { return $54dabcb7a6480b63$export$706cf9fcefe67c8e; });
$parcel$export(module.exports, "activateGoHomeLink", function () { return $54dabcb7a6480b63$export$3fc781af82c0c660; });
$parcel$export(module.exports, "MEDIA_CONSTRAINTS", function () { return $54dabcb7a6480b63$export$2464c9e69777d386; });

var $72lX3 = parcelRequire("72lX3");
const $54dabcb7a6480b63$export$ff3ad29dbb546598 = "/index.html?userid=";
const $54dabcb7a6480b63$export$36dfaec04418caa7 = "/index.html?collectionid=";
const $54dabcb7a6480b63$export$eb3485a690c2f0b8 = Object.freeze({
    none: 0,
    owner: 1,
    admin: 2,
    member: 3,
    guest: 4
});
const $54dabcb7a6480b63$export$a3c073b335a47d60 = Object.freeze({
    public: 1,
    onlyreg: 2,
    private: 3
});
const $54dabcb7a6480b63$export$eba8c17f4d7a3cd3 = {
    [$54dabcb7a6480b63$export$a3c073b335a47d60.public]: "badge-public",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.onlyreg]: "badge-onlyreg",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.private]: "badge-private"
};
const $54dabcb7a6480b63$export$ab4fdfae3dcd1a8f = {
    [$54dabcb7a6480b63$export$a3c073b335a47d60.public]: "PUBLIC",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.onlyreg]: "REG USERS",
    [$54dabcb7a6480b63$export$a3c073b335a47d60.private]: "PRIVATE"
};
const $54dabcb7a6480b63$export$f25eef55c66a4e9d = {
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.owner]: "badge-owner",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.admin]: "badge-admin",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.member]: "badge-member",
    [$54dabcb7a6480b63$export$eb3485a690c2f0b8.guest]: "badge-guest"
};
const $54dabcb7a6480b63$export$8afc507ca675ea0e = (loadingMessage)=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;${loadingMessage}`;
    loaderElement.classList.remove("loader-hidden");
};
const $54dabcb7a6480b63$export$81e46b314cb8d8e3 = ()=>{
    const loaderElement = document.getElementById("loader");
    loaderElement.classList.add("loader-hidden");
};
const $54dabcb7a6480b63$export$997d30e836e5c567 = async (apimethod, rqstmethod, body, useLoaderWithText)=>{
    const request = {
        method: rqstmethod || "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    if (body) request.body = JSON.stringify(body);
    try {
        useLoaderWithText && $54dabcb7a6480b63$export$8afc507ca675ea0e(useLoaderWithText);
        const sendRqst = await fetch((0, $72lX3.ENDPOINT) + apimethod, request);
        useLoaderWithText && $54dabcb7a6480b63$export$81e46b314cb8d8e3();
        const respToJson = await sendRqst.json();
        if (respToJson && !respToJson.error) return respToJson;
        else return (respToJson === null || respToJson === void 0 ? void 0 : respToJson.error) || "An error occurred";
    } catch (error) {
        useLoaderWithText && $54dabcb7a6480b63$export$81e46b314cb8d8e3();
        return error;
    }
};
const $54dabcb7a6480b63$export$706cf9fcefe67c8e = (str)=>{
    const lastAtPos = str.lastIndexOf("@");
    const lastDotPos = str.lastIndexOf(".");
    return lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf("@@") == -1 && lastDotPos > 2 && str.length - lastDotPos > 2;
};
const $54dabcb7a6480b63$export$3fc781af82c0c660 = ()=>{
    const goHomeLink = document.getElementById("goHome");
    if (window.location.host === "localhost:80" || window.location.origin === "http://localhost") goHomeLink.href = window.location.origin + "/index.html";
    else goHomeLink.href = window.location.origin;
};
const $54dabcb7a6480b63$export$95df08bae54cb4df = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $54dabcb7a6480b63$export$2464c9e69777d386 = {
    audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        latency: 0,
        channelCount: 1
    }
};

});
parcelRegister("72lX3", function(module, exports) {

$parcel$export(module.exports, "ENDPOINT", function () { return $51f9bf6c0a8acf40$export$1a23c4610ef05bed; });
$parcel$export(module.exports, "UPLOAD_ENDPOINT", function () { return $51f9bf6c0a8acf40$export$cdda3773e71b07e4; });
const $51f9bf6c0a8acf40$var$MODE = "DEV" // 'DEV', 'STAGE', 'PROD'
;
const $51f9bf6c0a8acf40$var$ENVIRONMENTS = {
    PROD: {
        ENDPOINT: "https://hiaudio.fr",
        UPLOAD_ENDPOINT: "https://hiaudio.fr/fileUpload"
    },
    STAGE: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    },
    DEV: {
        ENDPOINT: window.location.protocol + "//" + window.location.host,
        UPLOAD_ENDPOINT: window.location.protocol + "//" + window.location.host + "/fileUpload"
    }
};
const $51f9bf6c0a8acf40$export$1a23c4610ef05bed = $51f9bf6c0a8acf40$var$ENVIRONMENTS[$51f9bf6c0a8acf40$var$MODE].ENDPOINT;
const $51f9bf6c0a8acf40$export$cdda3773e71b07e4 = $51f9bf6c0a8acf40$var$ENVIRONMENTS[$51f9bf6c0a8acf40$var$MODE].UPLOAD_ENDPOINT;

});



var $7hG31 = parcelRequire("7hG31");
let $482243d5d57e1523$var$TEMP_EMAIL = null;
const $482243d5d57e1523$var$sendCodeButton = document.getElementById("sendcodebutton");
const $482243d5d57e1523$var$redirectToGoogleLogin = ()=>{
    window.location.href = "/googlelogin";
};
const $482243d5d57e1523$var$getUser = async ()=>{
    const data = await (0, $7hG31.callJsonApi)("/profile", "GET", null, "Loading user...");
    if (data.ok) window.location.href = window.location.origin + "/profile.html";
};
const $482243d5d57e1523$var$sendVerificationCode = async ()=>{
    const loginEmail = document.getElementById("inputloginemail").value;
    if ((0, $7hG31.looksLikeMail)(loginEmail)) {
        $482243d5d57e1523$var$sendCodeButton.disabled = true;
        const data = await (0, $7hG31.callJsonApi)("/generatelogincode/" + loginEmail, "PUT", null, "Sending code...");
        $482243d5d57e1523$var$sendCodeButton.disabled = false;
        if (data.ok) {
            $482243d5d57e1523$var$TEMP_EMAIL = loginEmail;
            document.getElementById("authmethodform").hidden = true;
            document.getElementById("validationcodefield").hidden = false;
        } else {
            document.getElementById("inputloginemail").classList.add("is-invalid");
            document.getElementById("validationEmailResult").innerText = data;
        }
    } else {
        document.getElementById("inputloginemail").classList.add("is-invalid");
        document.getElementById("validationEmailResult").innerText = "Sorry, invalid email address format.";
    }
};
const $482243d5d57e1523$var$requestCodeValidation = async ()=>{
    const codeIs = document.getElementById("verificationCode").value;
    const sixDigits = /\d{6}/;
    if (sixDigits.test(codeIs)) {
        const body = {
            email: $482243d5d57e1523$var$TEMP_EMAIL,
            code: codeIs
        };
        const data = await (0, $7hG31.callJsonApi)("/logincodevalidation", "POST", body, "Verification in process...");
        if (data.ok) {
            $482243d5d57e1523$var$TEMP_EMAIL = null;
            window.location.href = window.location.origin;
        } else {
            // TODO: if the code is expired display button to request a new one
            document.getElementById("verificationCode").classList.add("is-invalid");
            document.getElementById("validationCodeResult").innerText = "Wrong code, sorry";
        }
    } else {
        document.getElementById("verificationCode").classList.add("is-invalid");
        document.getElementById("validationCodeResult").innerText = "Sorry, invalid code format.";
    }
};
(0, $7hG31.activateGoHomeLink)();
document.getElementById("googleLoginButton").onclick = $482243d5d57e1523$var$redirectToGoogleLogin;
$482243d5d57e1523$var$sendCodeButton.onclick = $482243d5d57e1523$var$sendVerificationCode;
document.getElementById("inputloginemail").onkeydown = function(e) {
    if (e.key == "Enter") return $482243d5d57e1523$var$sendVerificationCode();
};
document.getElementById("validatecodebutton").onclick = $482243d5d57e1523$var$requestCodeValidation;
document.getElementById("verificationCode").onkeydown = function(e) {
    if (e.key == "Enter") return $482243d5d57e1523$var$requestCodeValidation();
};
$482243d5d57e1523$var$getUser();

})();
//# sourceMappingURL=login.24f59d87.js.map
